module.exports = __webpack_public_path__ + "static/media/logo.53527c18.svg";